module.exports = __webpack_public_path__ + "media/success.0c5704b7.mp3";